
import { computed, defineComponent, onMounted, ref } from 'vue';
import PointInfo from '@/components/organisms/point/PointInfo.vue';
import { usePoint } from '@/compositions/usePoint';
import { i18n } from '@/plugins/i18n';

type Props = {
  result: {
    type: 'GRANT';
    point: number;
    line: {
      link: string;
      displayName: string;
      pictureUrl?: string;
    };
  };
};

export default defineComponent<Props>({
  name: 'PointActionComplete',

  components: {
    PointInfo,
  },

  props: {
    success: {
      type: Boolean,
      default: false,
    },
    result: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props: Props) {
    const { get } = usePoint();

    const point = computed(() => props.result.point); // 獲得したポイント
    const line = computed(() => props.result.line);
    const currentPoint = ref<number | null>(null);

    const title = ref('');

    onMounted(async () => {
      if (props.result.type === 'GRANT' || props.result.type === 'GRANT_PRIVATE') {
        title.value = `${i18n.t('keyword.point')}を取得しました！`;
      }

      const { total } = await get();
      currentPoint.value = total;
    });

    return {
      point,
      currentPoint,
      title,
      line,
    };
  },
});
